import { languageList } from '@/constants';
import { LanguageDropdownButton } from './LanguageDropdownButton';
import { usePersistedLanguage } from './hooks';

export const LanguageDropdown = ({ className = '', position = '' }) => {
  const [language, handleLanguage] = usePersistedLanguage(languageList);
  return (
    <LanguageDropdownButton
      className={className}
      position={position}
      label={language?.text}
      onSelect={handleLanguage}
      items={languageList}
      value={language}
    />
  );
};
